const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatUsdCents = (cents) => usdFormatter.format(cents / 100);

export const formatProjectCostCents = (cents) => (
  cents == null ? '—' : formatUsdCents(cents)
);
